import { PromptConfirm } from '../..';
import { _ } from '../../../lib';
import { svrtsRequest } from '../../svrts-interface';
import { getFlattenedTags } from './tags';
export const mergeDocuments = (rs, selected) => {
    PromptConfirm({
        msg: 'Are you sure you want to merge these documents?',
        yes: callback => {
            actuallyRunMerge(rs, selected, callback);
        },
    });
};
const actuallyRunMerge = (rs, selected, callback) => {
    svrtsRequest({
        data: {
            funcID: [0, 64],
            checksumsToMerge: _.chain(selected)
                .map(x => x.Attachment?.Checksum)
                .compact()
                .uniq()
                .value(),
        },
        no: data => {
            callback(data.message);
        },
        yes: data => {
            createMergedNote(rs, selected, data.newChecksum, callback);
        },
    });
};
const createMergedNote = (rs, selected, newChecksum, callback) => {
    const titles = _.chain(selected)
        .map(x => x.Title)
        .compact()
        .uniq()
        .sort()
        .map(x => `- ${x}`)
        .value();
    const notes = _.chain(selected)
        .map(x => x.Note)
        .compact()
        .uniq()
        .sort()
        .value();
    const newNoteParts = [
        titles.length > 0 ? `Old titles:\n\n${titles.join('\n')}\n\n` : '',
        notes.length > 0 ? `Old notes:\n\n${notes.join('\n\n-----\n\n')}\n\n` : '',
    ];
    const editableTags = _.chain(getFlattenedTags(rs))
        .filter(x => !(x.NonEditable ?? false))
        .map(x => x.ID)
        .uniq()
        .value();
    rs.props.adding?.onAdd({
        note: {
            Title: 'Merged Document',
            Note: _.compact(newNoteParts).join('\n'),
            Attachment: newChecksum,
            Tags: _.chain(selected)
                .flatMap(x => x.Tags)
                .filter(x => editableTags.includes(x))
                .uniq()
                .value(),
        },
        onComplete: (newID, successOrError) => {
            if (_.isString(successOrError)) {
                callback(successOrError);
                return;
            }
            deleteOldPreMergeNotes(rs, selected, newID, callback);
        },
    });
};
const deleteOldPreMergeNotes = (rs, selected, newNoteID, callback) => {
    rs.props.deleting?.onDelete(selected.map(x => x.ID), result => {
        if (newNoteID) {
            rs.updateState({
                selectedNotes: [newNoteID],
            });
        }
        if (_.isString(result)) {
            console.error('Error deleting old notes after merging:', result);
        }
        callback(true);
    });
};
//# sourceMappingURL=merge-notes.js.map